export const ALLOWED_COUNTRIES = [
  { id: 1, label: 'United States' },
  { id: 3, label: 'Canada' }
];
